import { gql } from "@apollo/client";

const GET_FACTSHEETS = gql`
  query Factsheets(
    $page: Int!
    $pageSize: Int
    $optionalFilters: OptionalFactsheetFilters
    $sortBy: String
  ) {
    factsheets(
      page: $page
      pageSize: $pageSize
      optionalFilters: $optionalFilters
      sortBy: $sortBy
    ) {
      totalCount
      factsheets {
        heiID
        calendar {
          studentNomAutumnTerm
          studentNomSpringTerm
        }
        institution {
          country
          erasmusCode
          name
        }
      }
      page
      pageSize
    }
  }
`;

export default GET_FACTSHEETS;